import * as types from './types';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SUBSCRIPTION:
      return state;
    default:
      return state;
  }
};